import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'sortByDestination'
})
export class SortByDestinationPipe implements PipeTransform {
  transform(itinerary: any, itemsArray: any, datePipe: DatePipe): any {
    const _array: any = [];

    // TODO backend-fix: el endpoint de detalle de itinerario está devolviendo
    // `itinerary.destination = []` aunque los items sí traen su propio
    // `destination.iata_code` y `form.destination.city_name`. Esto hace que
    // este pipe no arme grupos y la lista de cards renderice vacía.
    // Cuando el backend proyecte los destinos del itinerario en la respuesta,
    // eliminar el fallback `buildDestinationsFromItems` y volver a iterar
    // directamente `itinerary.destination`.
    const baseDestinations = this.buildDestinationsFromItems(itinerary, itemsArray);
console.log('baseDestinations', baseDestinations);
    // Primero procesamos los destinos
    baseDestinations.forEach(destination => {
      _array.push({
        city: destination.destination_info.cityName ? destination.destination_info.cityName : destination.iata_code,
        arrival: new Date(destination.destination_info.arrival), // Guardamos como Date para ordenar
        formattedArrival: datePipe.transform(destination.destination_info.arrival, 'MMM dd, yyyy'),
        departure: new Date(destination.destination_info.departure), // Guardamos como Date para ordenar
        formattedDeparture: datePipe.transform(destination.destination_info.departure, 'MMM dd, yyyy'),
        iata: destination.iata_code,
        items: []
      });
    });

    // Asignamos items a cada destino
    _array.forEach(destination => {
      const dest = destination.items;
      itemsArray.forEach(item => {
        let itemDestination = (item.item.destination) ? item.item.destination.iata_code : item.item.payloadUpdate.products[0].destination;
        if (destination.iata === itemDestination) {
          item.item.expiration_date = item?.expiration_date || item.item.expiration_date;
          dest.push(item);
        }
      });
    });

    // Filtramos destinos sin items
    const filteredArray = _array.filter(destination => destination.items.length > 0);

    // Ordenamos por fecha arrival (de menor a mayor)
    filteredArray.sort((a, b) => {
      return a.arrival.getTime() - b.arrival.getTime();
    });

    // Convertimos las fechas Date a formato string para la vista
    return filteredArray.map(destination => {
      return {
        ...destination,
        arrival: destination.formattedArrival,
        departure: destination.formattedDeparture
      };
    });
  }

  // TODO backend-fix: ver TODO al inicio de `transform`. Este fallback deriva
  // los destinos del itinerario a partir de los propios items cuando el
  // backend no los está proyectando en `itinerary.destination`. Eliminar
  // cuando el backend devuelva los destinos correctamente.
  private buildDestinationsFromItems(itinerary: any, itemsArray: any[]): any[] {
    const fromItinerary = Array.isArray(itinerary?.destination) ? itinerary.destination : [];
    if (fromItinerary.length > 0) {
      return fromItinerary;
    }

    const seen = new Map<string, any>();
    (itemsArray || []).forEach((entry: any) => {
      const item = entry?.item;
      if (!item) return;

      const iata =
        item?.destination?.iata_code ??
        item?.payloadUpdate?.products?.[0]?.destination;

      if (!iata || seen.has(iata)) return;

      const arrival = item.arrivalDate ?? item?.stay?.startDate ?? null;
      const departure = item.departureDate ?? item?.stay?.endDate ?? null;
      const cityName =
        item?.form?.destination?.city_name ??
        item?.location ??
        iata;

      seen.set(iata, {
        iata_code: iata,
        destination_info: {
          cityName,
          arrival,
          departure,
        },
      });
    });

    return Array.from(seen.values());
  }
}
